import { InhaltlicheAenderungDisplayModel } from "@/api/model-index";
import { AenderungsantragService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class GetInhaltlicheAenderungResolver  {
    constructor(protected aenderungsantragService: AenderungsantragService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<InhaltlicheAenderungDisplayModel> {
        let id: string = <string>route.params['abschnittid'];

        await this.unfinishedHttpMethodsService.waitByUrl(state.url);

        const aenderungsantrag = await this.aenderungsantragService.apiAenderungsantragInhalticheAenderungIdGet({ id: id }).toPromise();

        this.portalContextService.CurrentAenderungsantrag = aenderungsantrag;

        return this.portalContextService.CurrentAenderungsantrag;
    }
}